__turbopack_context__.v({
  "className": "neuehaasunicafont_ceb9b3b-module__wKhJFW__className",
  "variable": "neuehaasunicafont_ceb9b3b-module__wKhJFW__variable",
});
